<script>
import SiteFooter from "@components/footer/footer.vue";
import SiteHeader from "@components/header/header.vue";
import SiteMenu from "@components/menu/menu.vue";
import SiteBanner from "@components/banner/banner.vue";
import SitePageHeader from "@components/page/page-header.vue";
import SitePageContent from "@components/page/page-content.vue";
import WhatsappButton from "@components/social/WhatsappButton.vue";

export default {
  components: {
    SiteFooter,
    SiteHeader,
    SiteMenu,
    SiteBanner,
    SitePageHeader,
    SitePageContent,
    WhatsappButton
  },

  props: {
    page: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: 'no description'
    }
  },

  computed: {
    currentYear () {
      return new Date().getFullYear();
    }
  }
}
</script>

<template>
  <div class="container-fluid d-flex h-100 flex-column p-0">
    <!--  logo and social networks -->
    <SiteHeader home="home" title="Bibliotecas Digitales"/>

    <!-- menu horizontal / vertical -->
    <SiteMenu :page="page"/>

    <!-- banner -->
    <SiteBanner />

    <!-- page header -->
    <SitePageHeader :page="page" :description="description"/>

    <!--  main content -->
    <SitePageContent>
      <slot />
    </SitePageContent>

    <!--  footer -->
    <SiteFooter>
      Bibliotecas Digitales® {{ currentYear }}
    </SiteFooter>

    <!--   create at https://create.wa.link/ -->
    <WhatsappButton destination="https://wa.link/59b63u"/>
  </div>
</template>

<style lang="scss">
</style>
